<template>
<div>
  
  
  <div  id="settingzone">
    <!-- <div id="back">
    <a href="/taskmanager">--返回主页---</a>
  </div> -->
    <!-- <div class="leftnav">
      <div>userinfo</div>
      <div>mode</div>
      <div>language</div>
      
    </div> -->
    <div  id="temp" class="">
    <header class="eae3d34f">
      <div class="_9dd31975 "><h1 id="settingtitle" class="_71a1610c eb373739 _2a3b75a1">设置</h1></div>
      <div class="_4bb9987d "></div>
    </header>
    <div id="menu" role="menu" aria-label="设置页面" tabindex="-1" >
      <ul id="leftmenugroup" >
       <a   @click="showrightcontent('profile')"   class="menutagname"><svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 12a8.96 8.96 0 001.778 5.372A8.987 8.987 0 0012 21a8.981 8.981 0 007.222-3.628A9 9 0 103 12zm9 3c2.747 0 5.259.472 6.562 1.577a8 8 0 10-13.124 0C6.74 15.472 9.253 15 12 15zm5.94 2.36A7.98 7.98 0 0112 20a7.98 7.98 0 01-5.94-2.64C7.022 16.518 9.18 16 12 16c2.82 0 4.978.519 5.94 1.36zM12 14a3.75 3.75 0 110-7.5 3.75 3.75 0 010 7.5zm2.75-3.75a2.75 2.75 0 11-5.5 0 2.75 2.75 0 015.5 0z" fill="currentColor"></path></svg>账户</a>
       <!-- <a class="menutagname" @click="showrightcontent('version')"  ><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.96 3a1 1 0 00-.996.918l-.088 1.07a7.157 7.157 0 00-1.34.545l-.811-.688a1 1 0 00-1.354.056l-1.47 1.47a1 1 0 00-.056 1.354l.688.81a7.157 7.157 0 00-.544 1.34l-1.071.089A1 1 0 003 10.96v2.08a1 1 0 00.918.996l1.134.094c.142.436.325.856.547 1.256l-.754.89a1 1 0 00.056 1.353l1.47 1.47a1 1 0 001.354.056l.957-.812c.378.188.771.344 1.177.463l.105 1.276a1 1 0 00.996.918h2.08a1 1 0 00.996-.918l.11-1.34c.378-.123.745-.279 1.096-.463l1.033.876a1 1 0 001.354-.056l1.47-1.47a1 1 0 00.056-1.354l-.876-1.033c.184-.351.34-.718.463-1.096l1.34-.11A1 1 0 0021 13.04v-2.08a1 1 0 00-.918-.996l-1.276-.105a7.15 7.15 0 00-.463-1.177l.812-.957a1 1 0 00-.056-1.354l-1.47-1.47a1 1 0 00-1.354-.056l-.889.754c-.4-.222-.82-.405-1.256-.547l-.094-1.134A1 1 0 0013.04 3h-2.08zm-.5 2.868a.5.5 0 00.383-.446L10.96 4h2.08l.12 1.474a.5.5 0 00.368.442c.582.158 1.136.4 1.646.718a.5.5 0 00.588-.043l1.16-.983 1.47 1.47-1.031 1.216a.5.5 0 00-.054.569 6.16 6.16 0 01.622 1.582.5.5 0 00.445.382L20 10.96v2.08l-1.679.138a.5.5 0 00-.441.366 6.159 6.159 0 01-.637 1.503.5.5 0 00.05.578l1.099 1.297-1.47 1.47-1.297-1.1a.5.5 0 00-.578-.049c-.47.278-.975.492-1.503.637a.5.5 0 00-.366.441L13.039 20H10.96l-.133-1.626a.5.5 0 00-.382-.445 6.16 6.16 0 01-1.582-.622.5.5 0 00-.569.054l-1.216 1.03-1.47-1.47.983-1.159a.5.5 0 00.043-.588 6.165 6.165 0 01-.718-1.646.5.5 0 00-.442-.367L4 13.04v-2.08l1.422-.117a.5.5 0 00.446-.382c.145-.61.381-1.192.7-1.728a.5.5 0 00-.048-.579l-.912-1.076 1.47-1.47 1.076.912a.5.5 0 00.58.049 6.159 6.159 0 011.727-.701zM12 15.5a3.5 3.5 0 110-7 3.5 3.5 0 010 7zm2.5-3.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" fill="currentColor"></path></svg>版本信息</a> -->
       <a  @click="showrightcontent('normal')"  class="menutagname" tabindex="-1"><svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M15 14.5a2 2 0 011.936 1.498L19.5 16a.5.5 0 010 1l-2.563.001a2 2 0 01-3.874 0L4.5 17a.5.5 0 010-1l8.563-.002A2 2 0 0115 14.5zm-.982 1.81l.005-.025-.005.026-.003.014-.004.025-.007.061A.897.897 0 0014 16.5l.008.125.007.047-.001.002.003.014.006.024h-.001l.004.018.016.058.007.021.004.013.009.026.013.033.012.027-.011-.026.019.043-.008-.017.029.06-.018-.037.048.09a1 1 0 001.785-.155l.014-.039.006-.018-.015.039.022-.06-.001-.001.016-.057.004-.018.005-.024.001-.006v-.001l.005-.033.008-.06A.877.877 0 0016 16.5l-.008-.124a.96.96 0 00-.007-.051l-.001-.001-.003-.014-.01-.047-.004-.016-.007-.024-.01-.034-.004-.012-.01-.03-.006-.013-.007-.017-.01-.026a1 1 0 00-1.844.043l-.013.034-.007.022-.014.047-.002.009v.001l-.005.016-.01.047zM9 9.5c.931 0 1.714.636 1.937 1.498L19.5 11a.5.5 0 010 1l-8.563.001a2 2 0 01-3.874 0L4.5 12a.5.5 0 010-1l2.564-.002A2 2 0 019 9.5zm0 1a1 1 0 00-.93.634l-.014.034-.007.022-.014.047-.002.009v.001l-.005.016-.01.047.005-.025-.005.026-.003.014-.004.025-.007.061C8 11.441 8 11.471 8 11.5l.008.125a.995.995 0 00.007.047l-.001.002.003.014.006.024h-.001l.004.018.016.058.007.021.004.013.009.026.013.033.012.027-.011-.026.019.043-.008-.017.029.06-.018-.037.048.09a1 1 0 001.785-.155l.014-.039.006-.018-.015.039.022-.06-.001-.001.016-.057.004-.018.005-.024.001-.006v-.001l.005-.033.008-.06A.877.877 0 0010 11.5l-.008-.124a.991.991 0 00-.007-.051l-.001-.001-.003-.014-.01-.047-.004-.016-.007-.024-.01-.034-.004-.012-.01-.03-.006-.013-.007-.017-.01-.026A1 1 0 009 10.5zm6-6a2 2 0 011.936 1.498L19.5 6a.5.5 0 010 1l-2.563.001a2 2 0 01-3.874 0L4.5 7a.5.5 0 010-1l8.563-.002A2 2 0 0115 4.5zm0 1a1 1 0 00-.93.634l-.014.034-.007.022-.014.047-.002.009v.001l-.005.016-.01.047.005-.025-.005.026-.003.014-.004.025-.007.061C14 6.441 14 6.471 14 6.5l.008.125.007.047-.001.002.003.014.006.024h-.001l.004.018.016.058.007.021.004.013.009.026.013.033.012.027-.011-.026.019.043-.008-.017.029.06-.018-.037.048.09a1 1 0 001.785-.155l.014-.039.006-.018-.015.039.022-.06-.001-.001.016-.057.004-.018.005-.024.001-.006v-.001l.005-.033.008-.06C16 6.557 16 6.528 16 6.5l-.008-.124a.96.96 0 00-.007-.051l-.001-.001-.003-.014-.01-.047-.004-.016-.007-.024-.01-.034-.004-.012-.01-.03-.006-.013-.007-.017-.01-.026A1 1 0 0015 5.5z" fill="currentColor"></path></svg>常规设置</a>
       <a  @click="showrightcontent('version')"  class="menutagname"  tabindex="-1"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.5 18.75C14 19.875 14.5 21 16 21c3 0 5-4 5-9s-4.03-9-9-9a9 9 0 00-9 9c0 7.418 2.751 6.307 5.397 5.238.92-.371 1.828-.738 2.603-.738 1.5 0 2 1.125 2.5 2.25zM20 12c0 4.664-1.796 8-4 8-.716 0-.985-.303-1.586-1.656-.899-2.022-1.63-2.844-3.414-2.844-.835 0-1.459.198-3.017.827l-.252.102c-1.478.59-2.188.714-2.622.453C4.453 16.49 4 15 4 12a8 8 0 018-8c4.429 0 8 3.563 8 8zm-2 3.5a1 1 0 11-2 0 1 1 0 012 0zm-.5-3a1 1 0 100-2 1 1 0 000 2zM16.75 8a1 1 0 11-2 0 1 1 0 012 0zM12 7.5a1 1 0 100-2 1 1 0 000 2zM9.25 8a1 1 0 11-2 0 1 1 0 012 0zM6.5 12.5a1 1 0 100-2 1 1 0 000 2z" fill="currentColor"></path></svg>版本信息</a>
       <a  @click="showrightcontent('author')" class="menutagname" tabindex="-1"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M19 4H5a2 2 0 00-2 2v12a2 2 0 002 2h14a2 2 0 002-2V6a2 2 0 00-2-2zM4 6a1 1 0 011-1h4v14H5a1 1 0 01-1-1V6zm6 13h9a1 1 0 001-1V6a1 1 0 00-1-1h-9v14z" fill="currentColor"></path></svg>联系我们</a>
    
       <div v-show=false>
            <a data-command="" id=":r68:" class="menutagname"  tabindex="-1"><svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M20 16h-1v1a1 1 0 01-1 1H6a1 1 0 01-1-1V7a1 1 0 011-1h12a1 1 0 011 1v1h1V7a2 2 0 00-2-2H6a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2v-1zm0-7h-6a2 2 0 00-2 2v2a2 2 0 002 2h6a1 1 0 001-1v-4a1 1 0 00-1-1zm-6 1a1 1 0 00-1 1v2a1 1 0 001 1h6v-4h-6zm4 3a1 1 0 100-2 1 1 0 000 2z" fill="currentColor"></path></svg>订购</a>
       
          <a data-command="" id=":r6b:" class="menutagname"  tabindex="-1"><svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M17 5H7a2 2 0 00-2 2v10a2 2 0 002 2h5.022c.23.359.494.694.788 1H7a3 3 0 01-3-3V7a3 3 0 013-3h10a3 3 0 013 3v2.498a6.45 6.45 0 00-1-.324V7a2 2 0 00-2-2zm.5 15a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm0 1a5.5 5.5 0 100-11 5.5 5.5 0 000 11zm0-8a.5.5 0 01.492.41l.008.09V15h1.5a.5.5 0 01.09.992L19.5 16H18v1.5a.5.5 0 01-.992.09L17 17.5V16h-1.5a.5.5 0 01-.09-.992L15.5 15H17v-1.5a.5.5 0 01.5-.5z" fill="currentColor"></path></svg>快速添加</a>
       <a data-command="" id=":r6c:" class="menutagname" tabindex="-1"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 12a9 9 0 1018 0 9 9 0 00-18 0zm17 0a8 8 0 01-15.382 3.089L7.5 12.207l2.646 2.647a.5.5 0 00.708 0L16 9.707V12a.5.5 0 001 0V8.5v-.003A.5.5 0 0016.5 8H13a.5.5 0 000 1h2.293L10.5 13.793l-2.646-2.647a.5.5 0 00-.708 0L4.26 14.032A8 8 0 1120 12z" fill="currentColor"></path></svg>效率</a>
       <a data-command="" id=":r6d:" class="menutagname"  tabindex="-1"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.854 5.354a1.974 1.974 0 00-.272 2.453.5.5 0 11-.843.538 2.974 2.974 0 014.106-4.106.5.5 0 01-.536.843 1.976 1.976 0 00-2.455.272zm11.839-.272a1.974 1.974 0 012.725 2.727.5.5 0 10.844.536 2.976 2.976 0 00-4.107-4.106.5.5 0 10.538.843zm.245 13.063A7.47 7.47 0 0112 20c-1.891 0-3.619-.7-4.938-1.855l-1.708 1.709a.5.5 0 11-.708-.708l1.709-1.708a7.5 7.5 0 1111.29 0l1.709 1.708a.5.5 0 11-.708.707l-1.708-1.708zM12 19a6.5 6.5 0 110-13 6.5 6.5 0 010 13zm0-11v4h2.5a.5.5 0 010 1h-3a.5.5 0 01-.5-.5V8a.5.5 0 111 0z" fill="currentColor"></path></svg>提醒</a>
       <a data-command="" id=":r6e:" class="menutagname"  tabindex="-1"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.475 19a1.5 1.5 0 01-1.254-2.323C5.568 14.625 6.25 11.989 6.25 8.75a5.75 5.75 0 1111.5 0c0 3.24.682 5.875 2.03 7.927A1.5 1.5 0 0118.524 19H14.5a2.5 2.5 0 01-5 0H5.475zM12 20.5a1.5 1.5 0 001.5-1.5h-3a1.5 1.5 0 001.5 1.5zm7.025-3a.5.5 0 01-.5.5H5.475a.5.5 0 01-.418-.774C6.519 14.998 7.25 12.172 7.25 8.75a4.75 4.75 0 019.5 0c0 3.423.731 6.249 2.193 8.476a.5.5 0 01.082.274z" fill="currentColor"></path></svg>通知</a>
       <a data-command="" id=":r6f:" class="menutagname"  tabindex="-1"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.25 18a3.75 3.75 0 01-1.243-7.29 3 3 0 013.81-3.098 5.5 5.5 0 0110.178 3.1A3.751 3.751 0 0117.751 18H14v-1h3.75a2.75 2.75 0 00.914-5.345l-.695-.245.028-.736L18 10.5a4.5 4.5 0 00-8.331-2.361l-.397.641-.726-.205a2.002 2.002 0 00-2.541 2.067l.053.76-.72.252A2.751 2.751 0 006.25 17H11v1H6.25zM13 11.707V20.5a.5.5 0 01-1 0v-8.793l-1.646 1.647a.5.5 0 01-.708-.708l2.5-2.5a.5.5 0 01.708 0l2.5 2.5a.5.5 0 01-.708.708L13 11.707z" fill="currentColor"></path></svg>备份</a>
       <a data-command="" id=":r6g:" class="menutagname" tabindex="-1"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.268 5H18a1 1 0 011 1v10.732A2 2 0 0020 15V6a2 2 0 00-2-2H9a2 2 0 00-1.732 1zM6 7h9a2 2 0 012 2v9a2 2 0 01-2 2H6a2 2 0 01-2-2V9a2 2 0 012-2zM5 9a1 1 0 011-1h9a1 1 0 011 1v9a1 1 0 01-1 1H6a1 1 0 01-1-1V9zm6 5h2.5a.5.5 0 000-1H11v-2.5a.5.5 0 00-1 0V13H7.5a.5.5 0 000 1H10v2.5a.5.5 0 001 0V14z" fill="currentColor"></path></svg>关联应用</a>
      </div>
      </ul>
          </div>
      </div>

    <div class="rightcontent">
      <div id="setting">
        <div id="userinfo" v-if="showprofile">
          💘尊贵的 {{ userlevel }} 用户🤞🏼,祝您使用愉快 
        </div>
        

        <div id="versioninfo" v-if="showversion">
          v{{ version }}
        </div>
      
      <div v-if="shownormal">
        <div v-if="showmode" v-show="false">
          travel/dreamer
          <a-switch v-model:checked="checked1" checked-children="traveler" un-checked-children="dreamer" />
          </div>
          <div>
          language:
         <a-switch v-model:checked="checked2" checked-children="English" un-checked-children="中文" />
         </div>

         <!-- 加入评价算法因子的计算 -->
         <div class="dayselectTool normalset" >
          <span>评价算法天数: </span>
          <a-select
      ref="select"
      v-model:value="selecteddays"
      style="width: 120px"
      @focus="focus"
      @change="handleChangeforreviewdays"
    >
      <a-select-option
        v-for="option in options1"
        :key="option.value"
        :value="option.value"
      >
        <div :class="{ 'vip-style': option.vip }">
          <span v-if="option.vip" class="vip-label">VIP</span>
          {{ option.label }}
        </div>
      </a-select-option>
    </a-select>
         </div>

         <div class="dayselectTool normalset" >
          <span>显示目标别名: </span>
          <a-select
            
            ref="select"
            v-model:value="selectedrecomendalgo"
            style="width: 120px"
            :options="options2"
            @focus="focus"
            @change="handleChange"
          ></a-select>
         </div>
         
    
         <div class="dayselectTool normalset" >
          <span>目标树状方式显示: </span>
      
          <a-select
      ref="select"
      v-model:value="selectedgoaltreeshow"
      @focus="focus"
   @change="handleChangeforgoaltreeshow"
       style="min-width: 100px"
    >
    <a-select-option
        v-for="option in optionsfortree"
        :key="option.value"
        :value="option.value"
      
      >
        <div :class="{ 'vip-style': option.vip === true }">
          <span v-if="option.vip" class="vip-label">VIP</span>
         {{ option.label }}
          
        </div>
      </a-select-option>
    </a-select>
         </div>

          
         <div class="dayselectTool normalset" >
          <span>故事书展示方式: </span>
      
          <a-select
      ref="select"
      v-model:value="selectedstoryorder"
      @focus="focus"
   @change="handleChangeforstoryorder"
       style="min-width: 100px"
    >
    <a-select-option
        v-for="option in optionsforstory"
        :key="option.value"
        :value="option.value"
      
      >
        <div :class="{ 'vip-style': option.vip === true }">
          <span v-if="option.vip" class="vip-label">VIP</span>
         {{ option.label }}
          
        </div>
      </a-select-option>
    </a-select>
         </div>


         <div class="dayselectTool normalset" >
          <span>推荐算法: </span>
      
          <a-select
      ref="select"
      v-model:value="selectedrecomenengine"
      @focus="focus"
   @change="handleChangeforrecommedengine"
       style="min-width: 100px"
    >
    <a-select-option
        v-for="option in recomendoptions"
        :key="option.value"
        :value="option.value"
      
      >
        <div :class="{ 'vip-style': option.vip === true }">
          <span v-if="option.vip" class="vip-label">VIP</span>
         {{ option.label }}
          
        </div>
      </a-select-option>
    </a-select>
         </div>

         <!-- <div class="fontelectTool normalset" >
          <span>选择字体: </span>
          <a-select
            
            ref="select"
            v-model:value="selectedfont"
            style="width: 120px"
            :options="fontoptions"
            @focus="focus"
            @change="handleChange"
          ></a-select>






         </div>
          -->
         
          <div class="fontelectTool normalset">
    <span>选择字体: </span>
    <a-select
      ref="select"
      v-model:value="selectedfont"
      @focus="focus"
   @change="handleChangeforfont"
    style="min-width: 200px"
    >
    <a-select-option
        v-for="option in fontoptions"
        :key="option.value"
        :value="option.value"
      
      >
        <div :class="{ 'vip-style': option.vip === true }">
          <span v-if="option.vip" class="vip-label">VIP</span>
         {{ option.label }}
          
        </div>
      </a-select-option>
      <a-select-option key="upload" value="upload">
        <CosUpload @uploadSuccess="addFontOption" />
      </a-select-option>
    </a-select>
  </div>
         
         <div>

        <a-radio-group v-show="false" v-model:value="selectedmode"  :defaultValue="2">
          <a-radio :value="1">mindmap</a-radio>
          <a-radio :value="2">gtd</a-radio>
        </a-radio-group>
      </div>
        <div v-if="showupdatebutton">
    <!-- <button>discard</button> -->
         <button id="updatebutton"  @click="updatesetting">保存设置</button>
        </div>
      </div>
      <div v-if="showauthor">
        加入内测计划,请发送邮件到thinking_for_life@163.com
      </div>
      
      
      </div>
    </div>
  
 </div>


</div>
</template>

<script>
import axios from 'axios';
import configure_options from '../configure'
import CosUpload from './cos.vue';
import { defineComponent ,ref,toRefs,reactive } from 'vue';
import emitter from "../eventbus.js"; 
import { notification } from 'ant-design-vue';
export default defineComponent({
  components: {
  CosUpload
  },
  setup() {
   var fontoptions = [
        { label: '默认', value: '默认', vip: false },
        { label: '楷体', value: 'KaiTi', vip: false },
        { label: '新宋体', value: 'NSimSun', vip: false },
        { label: '仿宋', value: 'FangSong', vip: false },
        { label: '黑体', value: 'SimHei', vip: false },
        
        { label: 'Helvetica', value: 'Helvetica', vip: false },
        { label: '科幻', value: 'scitext', vip: true },
        // { label: '阿里妈妈刀隶体', value: 'gofontchinese4', vip: false },
        // { label: '微软雅黑', value: 'Microsoft JHengHei', vip: false },
        // { label: '诗歌体', value: 'gofontchinese', vip: true },
        { label: '手写体', value: 'handwriting', vip: true },
        { label: '网红字体1', value: 'goodfont', vip: true },
        { label: '网红字体2', value: 'handwriting1', vip: true }
      ]
    var showmode = true;
      
   

function getuser() {
    var env = configure_options["env"];
    var serverhost = configure_options["app_setting"][env]["serverhost"];

    axios.get(serverhost + "/v1/userinfo").then(response => {
        var data = response.data;
        var userlevel = data["userlevel"];
        this.serveruserlevel = userlevel;

        var setting = data.setting;
        var showgoalalias = data["showgoalalias"];
        this.selectedfont = (() => {
            try {
                return setting.font || "default";
            } catch (e) {
                return "default";
            }
        })();

        this.selectedgoaltreeshow  = setting.goaltreechildstyle||"no"
        this.selectedstoryorder = setting.storyorder||"normal"
        this.previousValidFont = this.selectedfont;

        if (setting != "") {
            this.selecteddays = (() => {
                try {
                    return data["reviewofdays"] || 30;
                } catch (e) {
                    return 30;
                }
            })();
            this.previousValidDays = this.selecteddays;

            if (showgoalalias != "") {
                this.selectedshowgoalAlias = (showgoalalias === "yes") ? "是" : "否";
            }


            // 处理用户上传的字体
            const settingsObj = setting;
            const userUploadsFonts = settingsObj.useruploadsfonts || {};

            // 将用户上传的字体添加到现有的 fontoptions 中
            for (const [fontName, fontUrl] of Object.entries(userUploadsFonts)) {
                this.fontoptions.push({
                    label: fontName,
                    value: fontName,
                    url:fontUrl,
                    vip: false // 根据需要设置VIP标志
                });
            }
        }
    }).catch(error => {
        console.log("获取用户信息失败：", error);
    });
}

    var reviewdaysoptions = [
  {
    id: 0,
    value: 5,
    label: '5 天',
    vip: true
  },
  {
    id: 1,
    value: 10,
    label: '10 天',
    vip: true
  },
  {
    id: 2,
    value: 30,
    label: '30 天',
    vip: false
  },
  {
    id: 3,
    value: 60,
    label: '60 天',
    vip: true  // VIP专属选项
  },
  {
    id: 4,
    value: 120,
    label: '120 天',
    vip: true  // VIP专属选项
  }
];


                          var  options2 =  [{
                            id:0,
                            value:"是",  
                          },{
                            id:1,
                            value:"否"
                          }
                          
                          ]
   
                          var  optionsfortree =  [{
                            id:0,
                            label: '树状显示',
                            value:"yes",  
                            vip: true,
                          },{
                            id:1,
                            label: '平铺显示',
                            value:"no",
                            vip: false,
                          }
                          
                          ]

                          var  optionsforstory =  [{
                            id:0,
                            label: '正序',
                            value:"normal",  
                            vip: false,
                          },{
                            id:1,
                            label: '逆序',
                            value:"reverse",
                            vip: false,
                          }
                          
                          ]
                          // var  fontoptions =  [{
                          //   id:0,
                          //   value:"scitext",  
                          // },
                          
                          // {
                          //   id:1,
                          //   value:"default"
                          // }
                          // ,{
                          //   id:2,
                          //   value:"handwriting"
                          // }
                          // ]
                          const state = reactive({
      checked1: true,
      checked2: false,
      checked3: false,
      fontoptions,
      getuser,
      selectedmode:ref("2"),
      
      showupdatebutton:false,
      
    });
  
    return {
      
      ...toRefs(state),
      version:configure_options["version"],
      showupdatebutton:false,
     showmode,
     options1: reviewdaysoptions,
     options2,
     optionsfortree,
    //  fontoptions,
    recomendoptions: [
        { label: '未开启', value: 'default', vip: false },
        { label: '开启', value: 'yes', vip: true },],
     optionsforstory,
     showprofile:ref(true),
     showversion:ref(false),
     shownormal:ref(false),
     showauthor:ref(false),
     userlevel:ref("注册"),
     serveruserlevel:ref("default"),
     selecteddays:ref(30),
     selectedshowgoalAlias:ref("否"),
     selectedrecomendalgo:ref("否"),
     selectedgoaltreeshow:ref("否"),
     selectedstoryorder:ref("normal"),
     selectedfont:ref("default"),
     selectedrecomenengine:ref("default"),
     previousValidFont: ref("default"),
     previousValidRecomenengine:ref("default"),
     previousValidgoaltreeshowstyle:ref("default"),
     previousValidDays: ref(30),
     showdaySelect:ref(false),
     showzone:{profile:true,lang:false,version:false,normal:false,author:false}
    };

    
  },
  methods:{
    showrightcontent(type){
      // alert(type)

      console.log(type)
      for(const key in this.showzone){
        var newname = "show"+key
        if(key==type){
          
          this[newname]=true;
          // 江别的全部置为false

          // this.showversion = true;
          // this.showprofile = true;
          console.log(`对应的版本信息${newname}`)
          // console.log(`对应的版本信息${this.showversion} type is ${typeof this.showversion}`)
          // console.log(`对应的版本信息${this.showprofile}`)
        }else{
          
          this[newname]=false;

        }
      }
    },
    handleChangeforfont(value) {
      const selectedOption = this.fontoptions.find(option => option.value === value);
      if (selectedOption && this.checkUserPermission(selectedOption)) {
        // 如果通过权限检查，更新 selectedfont 和 previousValidFont
        this.selectedfont = value;
        this.previousValidFont = value;
      } else {
        // 如果没有权限，显示警告信息并恢复为之前有效的字体
        this.$message.warning('该字体为VIP专用，请升级会员！');
        this.selectedfont = this.previousValidFont; // 恢复为之前有效的字体
      }
    },
    handleChangeforrecommedengine(value) {
  // 根据选项值查找对应的推荐算法选项
  const selectedOption = this.recomendoptions.find(option => option.value === value);
  
  // 检查用户是否有权限使用该推荐算法
  if (selectedOption && this.checkUserPermission(selectedOption)) {
    // 如果用户有权限，更新 selectedrecomenengine 和 previousValidRecomenengine
    this.selectedrecomenengine = value;
    this.previousValidRecomenengine = value;
  } else {
    // 如果没有权限，显示警告信息并恢复为之前有效的推荐算法
    this.$message.warning('该推荐算法为VIP专用，请升级会员！');
    this.selectedrecomenengine = this.previousValidRecomenengine; // 恢复为之前有效的推荐算法
  }
},

handleChangeforgoaltreeshow(value) {
  const selectedOption = this.optionsfortree.find(option => option.value === value);

  
  if (selectedOption&&this.checkUserPermission(selectedOption)) {
    this.selectedgoaltreeshow = value;
    this.previousValidgoaltreeshowstyle = value;
  }else{
    this.$message.warning('该显示方式为为VIP专用，请升级会员！');
    this.selectedgoaltreeshow = "no"
  }
 


},



handleChangeforstoryorder(value) {
  const selectedOption = this.optionsforstory.find(option => option.value === value);

  
  if (selectedOption) {
    this.selectedstoryorder = value;
  
  }else{
   
   console.log("why so")
  }
 


},



    handleChangeforreviewdays(value) {
  const selectedOption = this.options1.find(option => option.value === value);
  
  if (selectedOption && this.checkUserPermission(selectedOption)) {
    // 如果通过权限检查，更新 selecteddays 和 previousValidDays
    this.selecteddays = value;
    this.previousValidDays = value;
  } else {
    // 如果没有权限，显示警告信息并恢复为之前有效的天数
    this.$message.warning('该选项为VIP专用，请升级会员！');
    this.selecteddays = this.previousValidDays; // 恢复为之前有效的天数
  }
},

    updatesetting(){
      // alert(1)
         console.log("服务器配置读取")
         console.log(configure_options)
       var env =  configure_options["env"]
       
        // console.log(configure_options["app_setting"][env])
        var serverhost =configure_options["app_setting"][env]["serverhost"]
        var settingmode
        var showgoalalias = "no"
        var goaltreechildstyle = "no"
        // TODO 将来可能需要调整成不同模式
        if(this.checked1==true){
         settingmode = "dreamer"
        }else{
            settingmode = "dreamer"
        }

        if(this.selectedshowgoalAlias=="是"){
              showgoalalias = "yes"
        }else{
             showgoalalias = "no"
            }

            if(this.selectedgoaltreeshow=="yes"){
              goaltreechildstyle = "yes"
        }else{
          goaltreechildstyle = "no"
            } 

        settingmode = "dreamer"
        var userinfo = {mode:settingmode,
          clent:"web",
        "reviewofdays":this.selecteddays,
        "showgoalalias":showgoalalias,
        "goaltreechildstyle":goaltreechildstyle,
        "font":this.selectedfont,
        "storyorder":this.selectedstoryorder
      }
        if(this.loginemail==""||this.loginpassword==""){
          alert("用户名与密码不能为空")
          return
        }


        axios.post(serverhost+ '/v1/updatesetting',userinfo).then(
            response=>{    notification.success({
  message: '成功通知',
  description: '设置更新成功。',
  style: {
    fontFamily: 'KaiTi, sans-serif',
    fontSize: '16px',
    color: '#333', // 字体颜色
  },
});
          emitter.emit("getuserinfo","fromsettingPage")
          console.log(response)
        //   if (response.data.mode=="travel"){
        //    this.$router.push("/travel")
        //   }else{
        //      this.$router.push("/taskmanager")
        //   }
        
            }

          ).catch(error=>{
            console.log(error)
            
            notification.error({
  message: '错误通知',
  description: '当前该服务不可用。',
  style: {
    fontFamily: 'KaiTi, sans-serif',
    fontSize: '16px',
    color: 'red', // 字体颜色
  },
});
          })
        
      },


      checkUserPermission(option) {
       console.log("❤️❤️❤️")
        console.log(option)
      if (option.vip && this.serveruserlevel !== 'vip' ) {
        // 如果是VIP选项且用户没有VIP权限，则显示警告并不允许选择
   
        return false;
      }
     
      // 如果用户有权限或选项不是VIP专用，则允许选择
      // this.selectedfont = option.value;
      return true;
    },
    

  },
  mounted(){
 
    var env = configure_options["env"]
    // alert(env)
    var _this =  this
    if(env=="product"){
      _this.showmode = false
      _this.getuser()
    }else{
      
      _this.showmode = true
      _this.getuser()
      // alert(_this.showmode)
    }
   

  const targetNode = document.getElementById('setting');

// Options for the observer (which mutations to observe)
const config = { attributes: true, childList: true, subtree: true };

// Callback function to execute when mutations are observed
const callback = (mutationList, observer) => {
    console.log(observer)
  for (const mutation of mutationList) {
    if (mutation.type === 'childList') {
        this.showupdatebutton=true;
      console.log('A child node has been added or removed.');
    } else if (mutation.type === 'attributes') {
      console.log(`The ${mutation.attributeName} attribute was modified.`);

    }
  }
};

// Create an observer instance linked to the callback function
const observer = new MutationObserver(callback);

// Start observing the target node for configured mutations
observer.observe(targetNode, config);
  }
});





</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.vip-style {
  font-weight: bold;
}

.vip-label {
  color: white;
  background-color: #ff4500; /* 使用鲜艳的橙红色 */
  border: 1px solid #ff4500;
  border-radius: 3px;
  padding: 2px 4px;
  font-size: 0.8em;
  margin-left: 5px;
  font-weight: bold; /* 加粗文本 */
}
#back{
  position: absolute;;
  left: 10%;
}

.normalset{
  margin-top:20px;
}

#setting{
    display: flex;
    flex-direction: column;
}

#settingzone{
  display: flex;
  flex-direction: columns;
 
  /* background:#ebf3f2; */
}

.leftnav{
  height: 100%;
  background: red;
  color:white;
  width: 90px;
  text-align: left;
  margin-left: 0px;
}

#settingtitle{
  margin-top: 20px;
  font-size:20px;
}



#updatebutton{
  /* background:none; */
     border-radius: 2px;
    position: absolute;
    bottom: 0%;
    right:0%;
    min-width: 50px;
    border-style: none;
    background: #ff9000;
}

#reference{
  font-family: fangsong;
  text-align: left;
  position:absolute;
  left: 40%;
}

.rightcontent{
  margin-top:20px;
  text-align: left;
}

#temp{
  display: flex;
  flex-direction: column;
  margin-right: 40px;
}
#menu{
  display: flex;
  flex-direction: column;
}
#leftmenugroup{
  display: flex;
  flex-direction: column;
}
ul {
    display: block;
    list-style-type: disc;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 40px;
}

.menutagname {
    padding: 4px;
    border-radius: 5px;
    font-size: 14px;
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color:black
}


</style>
